import moment from 'moment'
import { ChipLabel } from 'presentation/shared/components/StatusChip/styles'
import SupportText from 'presentation/shared/components/SupportText'
import React from 'react'
import * as S from './styles'
import { ReactComponent as CheckIcon } from 'presentation/assets/icons/secondary-check.svg'

type Props = {
  contactRegistrations: {
    contactType: string
    createdAt: Date
    contact: boolean
  }[]
}

export function AmbulatoryScheduleContactRegistarionHistory({
  contactRegistrations
}: Props) {
  return (
    <>
      <SupportText color="primary">
        Histórico de tentativas de contato ({' '}
        <strong>{contactRegistrations?.length}</strong> tentativas totais )
      </SupportText>
      <S.ContainerComments>
        <ul>
          {contactRegistrations.map((contactRegistration, index) => (
            <>
              <S.ContainerItem isEven={index % 2 !== 0}>
                <li>
                  Tentativa de contato por{' '}
                  <strong>{contactRegistration.contactType}</strong> às{' '}
                  {moment(new Date()).locale('pt-br').format('HH:MM')},{' '}
                  {new Intl.DateTimeFormat('pt-BR', {
                    dateStyle: 'long'
                  }).format(new Date())}
                </li>
                <ChipLabel
                  color={contactRegistration.contact ? 'secondary' : 'blue'}
                  fontSize="medium"
                >
                  <div>
                    {contactRegistration.contact ? (
                      <>
                        <CheckIcon />
                      </>
                    ) : (
                      'Sem Resposta'
                    )}
                  </div>
                </ChipLabel>
              </S.ContainerItem>
            </>
          ))}
        </ul>
      </S.ContainerComments>
    </>
  )
}
